import { InlineEditorCancelButton, InlineEditorLogic_EditMode, InlineEditorSaveButton } from '@tableau/vizportalclient-common-components';
import { TextFieldWidget } from '@tableau/widgets';
import React from 'react';

import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';

import { Formatters,Messages } from '../../codegen/Localize';
import { NAME_MAX_LENGTH } from '../constants/lensconstants';
import { isValidName } from './LensHeaderEditableName';

export interface LensInlineNameEdtitorEditModeProps {
  readonly editLogic: InlineEditorLogic_EditMode<string>;
  readonly errorMessage: string;
  readonly clearErrorMessage: () => void;
}

export function LensInlineNameEditorEditMode(props: LensInlineNameEdtitorEditModeProps): JSX.Element {
  const inputEl = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    inputEl.current?.focus();
  }, []);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newText = e.target.value.substring(0, NAME_MAX_LENGTH);
    props.errorMessage && props.clearErrorMessage();
    props.editLogic.setEditorStateWithinEditMode(newText);
    setMessage(getMessageForNameTextInput(newText));
  };

  const [message, setMessage] = React.useState(props.errorMessage || getMessageForNameTextInput(props.editLogic.editorState));

  return <span data-tb-test-id={'lens-name-edit'} className={SpaceHeaderStyles.EditableTitleEditContainer}>
    <TextFieldWidget
      testId='lens-name-edit'
      label={undefined}
      maxLength={NAME_MAX_LENGTH}
      onChange={onNameChange}
      value={props.editLogic.editorState}
      className={`${SpaceHeaderStyles.ColumnFlexGrow} ${SpaceHeaderStyles.EditableTitleInput}`}
      style={SpaceHeaderStyles.EditableTitleInputOverrides}
      message={props.errorMessage || message}
      valid={(!!props.errorMessage || !isValidName(props.editLogic.editorState)) ? false : undefined} // valid=undefined so textfield won't have green valid styling
      ref={inputEl}
    />
    <div className={SpaceHeaderStyles.ConfirmCancelButtons}>
      <InlineEditorCancelButton {...props.editLogic} />
      <InlineEditorSaveButton {...props.editLogic} />
    </div>
  </span>;
}

function getMessageForNameTextInput(value: string): string {
  if (value.trim().length === 0) {
    return Messages.lensNameWhitespaceError();
  } else if (value.length > NAME_MAX_LENGTH) {
    return Messages.lensNameTooLongError();
  } else {
    const remainingChars = NAME_MAX_LENGTH - value.length;
    return Messages.remainingCharacters({
      COUNT: remainingChars,
      COUNT_LOC: Formatters.formatCount(remainingChars)
    });
  }
}
